// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"351":"commons","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"351":"57ce583eb8f2d00e9c38","589":"a34199ea0c1289b436db","678":"3fd71db896c8eb6a710f","883":"58b69eac7e82db853b84"}[chunkId] + ".js";
};